module.exports = __webpack_public_path__ + "media/images/logo_realis-818b06414609810107e6fa7fe4f4cd8b.png";